export default "__VITE_ASSET__BzIGbT22__"